import {
  faFilter,
  faLock,
  faLockOpen,
  faPen,
  faPlus,
  faSearch,
  faSort,
  faSortDown,
  faSortUp,
  faTimes,
  faTrash,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";

const usersMock = Array.from({ length: 10 }, (_, i) => ({
  id: `UID${350 + i}`,
  nom: `darel ${i + 1}`,
  email: `darel${i + 1}@entreprise.com`,
  telephone: `6${Math.floor(10 + Math.random() * 900)}-${Math.floor(
    10 + Math.random() * 900
  )}23`,
  statut: i % 3 === 0 ? "Inactif" : "Actif",
  avatar: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 70)}`,
}));

export default function UserDashboard() {
  const [users, setUsers] = useState(usersMock);
  const [selectedUser, setSelectedUser] = useState(users[0]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    status: "all",
  });
  const [sortConfig, setSortConfig] = useState({ key: "id", direction: "asc" });
  const [showModal, setShowModal] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  // Gestion du tri
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedUsers = [...users].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });

  // Gestion des filtres
  const filteredUsers = sortedUsers.filter((user) => {
    const matchesSearch =
      user.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus =
      filters.status === "all" || user.statut.toLowerCase() === filters.status;

    return matchesSearch && matchesStatus;
  });

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return faSort;
    return sortConfig.direction === "asc" ? faSortUp : faSortDown;
  };

  // Gestion des utilisateurs
  const handleDelete = (id) => {
    if (window.confirm("Voulez-vous vraiment supprimer cet utilisateur ?")) {
      setUsers(users.filter((user) => user.id !== id));
      if (selectedUser?.id === id) {
        setSelectedUser(users.length > 1 ? users[0] : null);
      }
    }
  };

  const toggleUserStatus = (id) => {
    setUsers(
      users.map((user) =>
        user.id === id
          ? {
              ...user,
              statut: user.statut === "Actif" ? "Inactif" : "Actif",
            }
          : user
      )
    );
    if (selectedUser?.id === id) {
      setSelectedUser({
        ...selectedUser,
        statut: selectedUser.statut === "Actif" ? "Inactif" : "Actif",
      });
    }
  };

  // Gestion du modal
  const handleAddUser = () => {
    setIsEditing(false);
    setCurrentUser({
      id: `UID${
        Math.max(...users.map((u) => parseInt(u.id.substring(3)))) + 1
      }`,
      nom: "",
      email: "",
      telephone: "",
      statut: "Actif",
      avatar: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 70)}`,
    });
    setShowModal(true);
  };

  const handleEditUser = (user) => {
    setIsEditing(true);
    setCurrentUser({ ...user });
    setShowModal(true);
  };

  const handleSaveUser = () => {
    if (isEditing) {
      setUsers(users.map((u) => (u.id === currentUser.id ? currentUser : u)));
    } else {
      setUsers([...users, currentUser]);
    }
    setShowModal(false);
    setSelectedUser(currentUser);
  };

  return (
    <div
      className="container-fluid p-4"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      {/* Modal pour ajouter/modifier */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h5>
                {isEditing ? "Modifier Utilisateur" : "Nouvel Utilisateur"}
              </h5>
              <button className="btn-close" onClick={() => setShowModal(false)}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              <div className="mb-3 text-center">
                <img
                  src={currentUser.avatar}
                  alt="Avatar"
                  className="rounded-circle mb-2"
                  width="80"
                  height="80"
                />
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() =>
                    setCurrentUser({
                      ...currentUser,
                      avatar: `https://i.pravatar.cc/150?img=${Math.floor(
                        Math.random() * 70
                      )}`,
                    })
                  }
                >
                  Changer l'avatar
                </button>
              </div>
              <div className="mb-3">
                <label className="form-label">ID</label>
                <input
                  type="text"
                  className="form-control"
                  value={currentUser.id}
                  disabled
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Nom complet</label>
                <input
                  type="text"
                  className="form-control"
                  value={currentUser.nom}
                  onChange={(e) =>
                    setCurrentUser({ ...currentUser, nom: e.target.value })
                  }
                />
              </div>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={currentUser.email}
                    onChange={(e) =>
                      setCurrentUser({ ...currentUser, email: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Téléphone</label>
                  <input
                    type="tel"
                    className="form-control"
                    value={currentUser.telephone}
                    onChange={(e) =>
                      setCurrentUser({
                        ...currentUser,
                        telephone: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Statut</label>
                <select
                  className="form-select"
                  value={currentUser.statut}
                  onChange={(e) =>
                    setCurrentUser({ ...currentUser, statut: e.target.value })
                  }
                >
                  <option value="Actif">Actif</option>
                  <option value="Inactif">Inactif</option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Annuler
              </button>
              <button className="btn btn-primary" onClick={handleSaveUser}>
                {isEditing ? "Enregistrer" : "Ajouter"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* En-tête */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="mb-0 text-dark fw-bold">
            <FontAwesomeIcon icon={faUser} className="me-2 text-primary" />
            Gestion des Utilisateurs
          </h4>
          <small className="text-muted">
            {filteredUsers.length} utilisateur(s) trouvé(s) •{" "}
            {users.filter((u) => u.statut === "Actif").length} actifs
          </small>
        </div>
        <button
          className="btn btn-primary rounded-pill px-4"
          onClick={handleAddUser}
        >
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          Ajouter un Utilisateur
        </button>
      </div>

      {/* Filtres */}
      <div className="card shadow-sm border-0 mb-4">
        <div className="card-body p-3">
          <div className="row g-2">
            <div className="col-md-8">
              <div className="input-group border rounded-3">
                <span className="input-group-text bg-white border-0">
                  <FontAwesomeIcon icon={faSearch} className="text-muted" />
                </span>
                <input
                  type="text"
                  className="form-control border-0"
                  placeholder="Rechercher par nom ou email..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="input-group border rounded-3">
                <span className="input-group-text bg-white border-0">
                  <FontAwesomeIcon icon={faFilter} className="text-muted" />
                </span>
                <select
                  className="form-select border-0"
                  value={filters.status}
                  onChange={(e) =>
                    setFilters({ ...filters, status: e.target.value })
                  }
                >
                  <option value="all">Tous les statuts</option>
                  <option value="actif">Actif</option>
                  <option value="inactif">Inactif</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contenu principal */}
      <div className="row">
        {/* Liste des utilisateurs */}
        <div className="col-lg-8">
          <div className="card shadow-sm border-0">
            <div className="card-body p-0">
              <div className="table-responsive rounded-3 overflow-hidden">
                <table className="table table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th
                        onClick={() => handleSort("id")}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex align-items-center">
                          ID
                          <FontAwesomeIcon
                            icon={getSortIcon("id")}
                            className="ms-2 text-muted"
                          />
                        </div>
                      </th>
                      <th
                        onClick={() => handleSort("nom")}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex align-items-center">
                          Nom
                          <FontAwesomeIcon
                            icon={getSortIcon("nom")}
                            className="ms-2 text-muted"
                          />
                        </div>
                      </th>
                      <th>Email</th>
                      <th>Téléphone</th>
                      <th
                        onClick={() => handleSort("statut")}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex align-items-center">
                          Statut
                          <FontAwesomeIcon
                            icon={getSortIcon("statut")}
                            className="ms-2 text-muted"
                          />
                        </div>
                      </th>
                      <th style={{ width: "100px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredUsers.map((user) => (
                      <tr
                        key={user.id}
                        onClick={() => setSelectedUser(user)}
                        className={
                          selectedUser?.id === user.id
                            ? "bg-primary bg-opacity-10"
                            : ""
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <td className="fw-bold text-primary">{user.id}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            <img
                              src={user.avatar}
                              alt={user.nom}
                              className="rounded-circle me-2"
                              width="32"
                              height="32"
                            />
                            {user.nom}
                          </div>
                        </td>
                        <td>
                          <a
                            href={`mailto:${user.email}`}
                            className="text-decoration-none"
                            onClick={(e) => e.stopPropagation()}
                          >
                            {user.email}
                          </a>
                        </td>
                        <td>
                          <a
                            href={`tel:${user.telephone.replace(/\D/g, "")}`}
                            className="text-decoration-none"
                            onClick={(e) => e.stopPropagation()}
                          >
                            {user.telephone}
                          </a>
                        </td>
                        <td>
                          <span
                            className={`badge rounded-pill ${
                              user.statut === "Actif"
                                ? "bg-success bg-opacity-10 text-success"
                                : "bg-danger bg-opacity-10 text-danger"
                            }`}
                          >
                            <FontAwesomeIcon
                              icon={
                                user.statut === "Actif" ? faLockOpen : faLock
                              }
                              className="me-1"
                            />
                            {user.statut}
                          </span>
                        </td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-secondary rounded-circle"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditUser(user);
                            }}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Détails de l'utilisateur */}
        <div className="col-lg-4">
          {selectedUser ? (
            <div className="card shadow-sm border-0 h-100">
              <div className="card-header bg-white border-0">
                <h5 className="mb-0 text-dark fw-bold">
                  Détails de l'utilisateur
                </h5>
              </div>
              <div className="card-body d-flex flex-column">
                <div className="text-center mb-4">
                  <img
                    src={selectedUser.avatar}
                    alt={selectedUser.nom}
                    className="rounded-circle shadow-sm"
                    width="120"
                    height="120"
                  />
                </div>
                <div className="mb-4 text-center">
                  <h4 className="text-dark fw-bold mb-1">{selectedUser.nom}</h4>
                  <span
                    className={`badge ${
                      selectedUser.statut === "Actif"
                        ? "bg-success bg-opacity-10 text-success"
                        : "bg-danger bg-opacity-10 text-danger"
                    } rounded-pill px-3 py-1`}
                  >
                    {selectedUser.statut}
                  </span>
                </div>

                <div className="mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0 text-muted text-uppercase small">
                      Informations
                    </h6>
                    <button
                      className="btn btn-sm btn-outline-primary rounded-pill px-3"
                      onClick={() => handleEditUser(selectedUser)}
                    >
                      <FontAwesomeIcon icon={faPen} className="me-1" />
                      Modifier
                    </button>
                  </div>

                  <div className="list-group list-group-flush">
                    <div className="list-group-item bg-transparent border-0 px-0 py-2">
                      <small className="text-muted d-block">Email</small>
                      <a
                        href={`mailto:${selectedUser.email}`}
                        className="text-decoration-none"
                      >
                        {selectedUser.email}
                      </a>
                    </div>
                    <div className="list-group-item bg-transparent border-0 px-0 py-2">
                      <small className="text-muted d-block">Téléphone</small>
                      <a
                        href={`tel:${selectedUser.telephone.replace(
                          /\D/g,
                          ""
                        )}`}
                        className="text-decoration-none"
                      >
                        {selectedUser.telephone}
                      </a>
                    </div>
                    <div className="list-group-item bg-transparent border-0 px-0 py-2">
                      <small className="text-muted d-block">Statut</small>
                      <span
                        className={`badge ${
                          selectedUser.statut === "Actif"
                            ? "bg-success bg-opacity-10 text-success"
                            : "bg-danger bg-opacity-10 text-danger"
                        } rounded-pill`}
                      >
                        {selectedUser.statut}
                      </span>
                    </div>
                    <div className="list-group-item bg-transparent border-0 px-0 py-2">
                      <small className="text-muted d-block">ID</small>
                      <span>{selectedUser.id}</span>
                    </div>
                  </div>
                </div>

                <div className="mt-auto">
                  <div className="d-grid gap-2">
                    <button
                      className="btn btn-outline-secondary rounded-pill"
                      onClick={() => toggleUserStatus(selectedUser.id)}
                    >
                      {selectedUser.statut === "Actif" ? (
                        <>
                          <FontAwesomeIcon icon={faLock} className="me-2" />
                          Désactiver le compte
                        </>
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faLockOpen} className="me-2" />
                          Activer le compte
                        </>
                      )}
                    </button>
                    <button
                      className="btn btn-outline-danger rounded-pill"
                      onClick={() => handleDelete(selectedUser.id)}
                    >
                      <FontAwesomeIcon icon={faTrash} className="me-2" />
                      Supprimer l'utilisateur
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body d-flex align-items-center justify-content-center">
                <p className="text-muted mb-0">
                  Sélectionnez un utilisateur pour afficher les détails
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Styles CSS */}
      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1050;
        }

        .modal-content {
          background-color: white;
          border-radius: 0.5rem;
          width: 90%;
          max-width: 600px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
        }

        .modal-header {
          padding: 1rem;
          border-bottom: 1px solid #dee2e6;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .modal-body {
          padding: 1rem;
        }

        .modal-footer {
          padding: 1rem;
          border-top: 1px solid #dee2e6;
          display: flex;
          justify-content: flex-end;
          gap: 0.5rem;
        }

        .btn-close {
          background: none;
          border: none;
          font-size: 1.5rem;
          opacity: 0.5;
          cursor: pointer;
        }

        .btn-close:hover {
          opacity: 0.75;
        }
      `}</style>
    </div>
  );
}
